import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { logout } from '../../store/userSlice';
import useChatNotifications from '../../hooks/useChatNotifications';

const AdminNav = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { unreadCount } = useChatNotifications("admin");

  const handleLogout = () => {
    dispatch(logout());
    localStorage.removeItem('UserInfo');
    navigate('/login');
  };

  return (
    <nav className="admin-nav">
      <ul>
        <li>
          <NavLink to="/admin-dashboard" className={({ isActive }) => (isActive ? "active" : "")}>
            <i className="bi bi-grid-1x2-fill" /> Dashboard
          </NavLink>
        </li>
        <li>
          <NavLink to="/hospital-listing" className={({ isActive }) => (isActive ? "active" : "")}>
            <i className="bi bi-hospital-fill" /> Hospitals
          </NavLink>
        </li>
        <li>
          <NavLink to="/admin-users" className={({ isActive }) => (isActive ? "active" : "")}>
            <i className="bi bi-people-fill" /> Users
          </NavLink>
        </li>
        <li>
          <NavLink to="/admin-jobs" className={({ isActive }) => (isActive ? "active" : "")}>
            <i className="bi bi-briefcase-fill" /> Jobs
          </NavLink>
        </li>
        <li>
          <NavLink to="/admin-payments" className={({ isActive }) => (isActive ? "active" : "")}>
            <i className="bi bi-credit-card-2-front-fill" /> Payments
          </NavLink>
        </li>
        <li>
          <NavLink to="/subscriptions" className={({ isActive }) => (isActive ? "active" : "")}>
            <i className="bi bi-sliders2" /> Category & Pricing
          </NavLink>
        </li>
        <li>
          <NavLink to="/admin-blogs" className={({ isActive }) => (isActive ? "active" : "")}>
            <i className="bi bi-journal-richtext" /> Blogs
          </NavLink>
        </li>
        <li>
          <NavLink to="/admin-chat" className={({ isActive }) => (isActive ? "active" : "")}>
            <i className="bi bi-chat-left-dots-fill" /> Chat
            {unreadCount > 0 && <span className="admin-badge">{unreadCount}</span>}
          </NavLink>
        </li>
      </ul>
      <button className="admin-logout" type="button" onClick={handleLogout}>
        <i className="bi bi-box-arrow-right" /> Log Out
      </button>
    </nav>
  );
};

export default AdminNav;
